import { blue, orange, grey, green, blueGrey } from '@mui/material/colors'
import { InquiryStatusType } from '@schemas'

/**
 * 문의 게시판 관리(/main/inquiry) 공통 상수.
 * 목록 카드와 타임라인 드로어가 같은 라벨·색을 쓴다.
 */

export const INQUIRY_STATUS_OPTIONS: { value: InquiryStatusType; label: string }[] = [
	{ value: 'new', label: '신규' },
	{ value: 'in_progress', label: '처리중' },
	{ value: 'pending', label: '대기' },
	{ value: 'resolved', label: '해결' },
	{ value: 'closed', label: '종료' },
]

export const INQUIRY_FILTER_OPTIONS: {
	value: InquiryStatusType | 'all'
	label: string
}[] = [{ value: 'all', label: '전체' }, ...INQUIRY_STATUS_OPTIONS]

export const INQUIRY_STATUS_COLOR: Record<string, string> = {
	new: blue[600],
	in_progress: orange[700],
	pending: grey[500],
	resolved: green[600],
	closed: blueGrey[700],
}

export const INQUIRY_STATUS_LABEL: Record<string, string> = Object.fromEntries(
	INQUIRY_STATUS_OPTIONS.map(anOption => [anOption.value, anOption.label]),
)

// Contact 페이지(monolith/Contact.page.tsx) 의 topicList 와 1:1. 한쪽에 항목을 넣으면 여기도 넣는다.
export const INQUIRY_CATEG_LABEL: Record<string, string> = {
	productInquiries: '제품 문의',
	orderSupport: '주문 지원',
	warrantyRepair: '보증/수리',
	softwareInquiries: '소프트웨어 문의',
	worksWithDevice: 'Works with 장비 추가/수정',
	dealerWholesale: '딜러/도매',
	feedbackSuggestions: '피드백/제안',
	collaborationOpportunities: '협업 제안',
	otherQuestions: '기타 문의',
}

/**
 * 이메일 답변 제목 — ASCII 인쇄 문자만(한글 · em dash 불가). 서버(`sendInquiryReply`)와 같은 규칙.
 * 기본 제목은 Contact 의 영어 라벨로 만든다(contactTopicLabel). 이 라벨 표(INQUIRY_CATEG_LABEL)는 화면용 한글이라 쓰지 않는다.
 */
export const INQUIRY_SUBJECT_PATTERN = /^[\x20-\x7E]+$/

/**
 * 고객에게 나가는 스태프 이름 — 영어가 아니면 'Administrator'(서버 toCustomerFacingStaffName 과 같은 규칙).
 * USERS.NAME 은 백오피스 표시용이라 한글일 수 있다(`운영자`). 답변 기본 서명에 쓴다.
 */
export const customerFacingStaffName = (name: string): string => {
	const trimmed = (name ?? '').trim()
	return trimmed !== '' && INQUIRY_SUBJECT_PATTERN.test(trimmed)
		? trimmed
		: 'Administrator'
}

/** 무한 스크롤 한 페이지 크기. 서버 최대 100. */
export const INQUIRY_PAGE_SIZE = 30

/** 타임라인 드로어 폭 */
export const INQUIRY_DRAWER_WIDTH = '26rem'

/** 이메일 답변 발신 주소 — 스태프 개인 주소가 아니라 CS 한 주소. 서버 INQUIRY_REPLY_FROM_ADDRESS 와 같아야 한다 */
export const INQUIRY_REPLY_FROM_ADDRESS = 'cs@judahs.io'
export const INQUIRY_REPLY_FROM_NAME = 'Judahs Support'
